export default __webpack_public_path__ + "static/media/lapologo.2ae0fc3b.PNG";